import { render, staticRenderFns } from "./getReward.vue?vue&type=template&id=7a360e50&scoped=true&lang=pug&"
import script from "./getReward.vue?vue&type=script&lang=js&"
export * from "./getReward.vue?vue&type=script&lang=js&"
import style0 from "./getReward.vue?vue&type=style&index=0&id=7a360e50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a360e50",
  null
  
)

export default component.exports